import { Button } from 'antd'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { poppins } from '@/components/common/fonts'

export const CreateVoiceCard: FC<{
  onClick?: () => void
}> = ({ onClick }) => {
  const { t } = useTranslation('common')

  return (
    <CreateVoiceCardContainer>
      {t('You can create your own AI voice!')}
      <CreateVoiceButton onClick={onClick}>
        {t('Create Voice')}
      </CreateVoiceButton>
    </CreateVoiceCardContainer>
  )
}

const CreateVoiceCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 88px;

  border: 1px solid #cccccc80;
  border-radius: 8px;

  font-family: ${poppins.string};
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
`

const CreateVoiceButton = styled(Button)`
  height: 32px;
  padding-inline: 16px;

  border: 1px solid #cccccc;

  font-family: ${poppins.string};
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #444444;
`
